import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import ConfigComponent from '../components/Config/ConfigComponent';
import StaticDataInitializer from '../components/Config/StaticDataInitializer';
import BaseModal from '../components/Modals/BaseModal';
import SpinnerOverlay from '../components/Spinner/SpinnerOverlay';
import AppRouterWithConfig from './AppRouterWithConfig';

export interface IAppRouterProps {
  store: Store;
}
export default class AppRouter extends React.Component<IAppRouterProps> {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <ConfigComponent>
          <StaticDataInitializer />
          <AppRouterWithConfig />
          <BaseModal />
          <SpinnerOverlay />
        </ConfigComponent>
      </Provider>
    );
  }
}
